import React from 'react';
import { journeyItems } from '../mock';

export default function StartJourney() {
  return (
    <section className="w-full bg-white py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-3">Get Started</div>
          <h2 className="serif text-4xl md:text-5xl font-light text-[#1a1a1a]">Start Your Premium Tiles &amp; Bathware Journey</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {journeyItems.map((j) => (
            <a href="#" key={j.name} className="group relative block h-56 md:h-72 img-zoom bg-neutral-200">
              <img src={j.image} alt={j.name} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 text-white flex items-center justify-between">
                <span className="serif text-xl md:text-2xl font-light">{j.name}</span>
                <span className="opacity-0 group-hover:opacity-100 group-hover:translate-x-0 -translate-x-2 transition-all">&rarr;</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
